import React from 'react';
import { i18n } from '@lt/localization';
import { VISA_TYPES, VISA_NAMES } from '../../store/domains/visa';

import type { IVisaInfo } from '../../CheckoutRoutes/PackageCheckout/components/Hotel/components/types';

const getVisaDescription = (type, visaSupport) => {
  switch (type) {
    case VISA_TYPES.NO_VISA:
      return null;
    case VISA_TYPES.ON_ARRIVAL_VISA:
      return i18n.t('checkout.visa.onArrival.description');
    default:
      return i18n.t('checkout.visa.support', {
        context: visaSupport ? '' : 'no',
      });
  }
};

const VisaInfo = ({
  type,
  visaSupport,
  className = '',
}: IVisaInfo): JSX.Element => (
  <div className={`visa-info__container ${className}`}>
    <div className="visa-info__type">{VISA_NAMES[type]}</div>
    <div className="visa-info__text">
      {getVisaDescription(type, visaSupport)}
    </div>
  </div>
);

export default VisaInfo;
